import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AtgNoB2BUnitPageComponent } from './atg-no-b2b-unit-page.component';
import { CmsConfig, ConfigModule } from '@spartacus/core';

@NgModule({
  declarations: [AtgNoB2BUnitPageComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AtgNoB2BUnitPageComponent: {
          component: () =>
            import('./atg-no-b2b-unit-page.component').then((c) => c.AtgNoB2BUnitPageComponent),
        },
      },
    } as CmsConfig),
  ],
  exports: [AtgNoB2BUnitPageComponent],
})
export class AtgNoB2BUnitPageModule { }
